import { systemtheme } from "orcs-design-system";

export const types = {
  demand: "allocatedFte",
  supply: "capacityFte",
};

export const dataTypes = {
  [types.demand]: { name: "Demand", color: systemtheme.colors.success },
  [types.supply]: { name: "Supply", color: systemtheme.colors.secondary },
};

export const getConfigForChart = (demandLabel, supplyLabel) => {
  return {
    [types.demand]: {
      ...dataTypes[types.demand],
      name: demandLabel,
    },
    [types.supply]: {
      ...dataTypes[types.supply],
      name: supplyLabel,
    },
  };
};
